import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

export default {
  /**
   * Fetch the Basic Information
   * @returns {any} Promise
   */
  fetchConnectorActive: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/cpo/v1/end-consumer/get-end-consumer-status`);
  },

  /**
   * Fetch all connector ratings
   * @param {any} parameters - Query parameters
   * @returns {any} Promise
   */
  fetchConnectorRatings: (parameters?: any): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings`,
      parameters,
    );
  },

  /**
   * Export connector ratings data
   * @param {any} [parameters] - Query parameters
   * @returns {Promise<any>} A promise that resolves with the export data
   */
  exportConnectorRatings: (parameters?: any): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/export`,
      parameters,
    );
  },

  /**
   * Create connector rating
   * @param {any} data - The rating data to create
   * @returns {any} The create response
   */
  createConnectorRating: (data: any): Promise<any> => {
    return postRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings`,
      data,
    );
  },

  /**
   * Edit connector rating via PATCH
   * @param {any} data - The rating data to edit (id + changed fields)
   * @param {string} data.id - The connector rating ID
   * @returns {any} The edit response
   */
  editConnectorRating: (data: { id: string; [key: string]: any }): Promise<any> => {
    const { id, ...payload } = data;
    return patchRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/${id}`,
      payload,
    );
  },

  /**
   * Delete connector rating
   * @param {any} id - The rating ID to delete
   * @returns {any} The delete response
   */
  deleteConnectorRating: (id: string): Promise<any> => {
    return deleteRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/${id}`,
    );
  },

  /**
   * Fetch connector rating filter list
   * @returns {any} Promise
   */
  fetchConnectorRatingFilterList: (): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/filters`,
    );
  },

  /**
   * Fetch the all connector rating list
   * @returns {any} Promise
   */
  fetchConnectorRatingAllList: (): Promise<any> => {
    return getRequest(`${config.tariffApiUrl}api/cpo/v1/rating/all-list`, {});
  },

  /**
   * Fetch the all connector rating scope list
   * @param {any} scopeId - scope id
   * @returns {any} Promise
   */
  fetchConnectorScopList: (scopeId: string): Promise<any> => {
    return getRequest(`${config.tariffApiUrl}api/cpo/v1/rating/get-scope-list`, {
      scopeId: scopeId || undefined,
    });
  },
};
